















import { Ref, Prop, Vue, Component, Watch } from "vue-property-decorator";
import * as _ from 'lodash';
import { TokenFieldValue } from '../model/frontend/BulkIssueTemplate';

@Component({
	components: {},
})
export default class TokenField extends Vue {
    @Prop()
    public value!: TokenFieldValue;

    @Prop()
    public type?: string; // NOTE: This currently doesn't do anything. TODO: support textarea?

    @Ref()
    public tokenField!: HTMLDivElement;

    private observer: MutationObserver | null = null;

    public mounted()
    {
        this.observer = new MutationObserver(() => this.onChanged());
        this.observer.observe(this.tokenField, { characterData: true, subtree: true });
    }

    public destroyed()
    {
        if (this.observer)
        {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    private isHandlingChange = false;

    @Watch('value', { deep: true, immediate: true })
    public onValueChanged(newValue: TokenFieldValue)
    {
        setTimeout(() => {
            if (!_.isEqual(newValue, this.getValue()))
            {
                let html = newValue.map(v => (v.type == 'token') ? `<div contenteditable="false" class="tag">${v.contents}</div>` : `<span>${v.contents}</span>`).join('');
                this.tokenField.innerHTML = html;
            }
        }, 0);
    }

    private getValue()
    {
        let result: TokenFieldValue = [];

        for (let childNode = this.tokenField.firstElementChild; childNode != null; childNode = childNode.nextElementSibling)
        {
            if (childNode instanceof HTMLElement && childNode.getAttribute('class') == 'tag')
            {
                result.push({ type: 'token', contents: childNode.innerText });
            }
            else if (childNode instanceof HTMLSpanElement)
            {
                result.push({ type: 'text', contents: childNode.innerText });
            }
        }

        return result;
    }

    private onChanged()
    {
        if (!this.isHandlingChange)
        {
            this.isHandlingChange = true;

            let selection = window.getSelection();
            if (selection && selection.isCollapsed)
            {
                let range = selection.getRangeAt(0);

                if (range)
                {
                    for (let childNode = this.tokenField.firstElementChild; childNode != null; childNode = childNode.nextElementSibling)
                    {
                        if (childNode instanceof HTMLSpanElement)
                        {
                            if (range && childNode.contains(range.startContainer) && childNode.childNodes.length > 1)
                            {
                                let offset = range.startOffset;
                                childNode.innerText = childNode.innerText;
                                break;
                            }
                        }
                    }
                }
            }

            this.isHandlingChange = false;

            this.$emit('input', this.getValue());
        }
    }

    public addToken()
    {
        let selection = window.getSelection();

        if (selection && this.tokenField.contains(selection.anchorNode) && this.tokenField.contains(selection.focusNode))
        {
            let range = selection.getRangeAt(0);

            if (range)
            {
                range.deleteContents();

                let node = range.startContainer;
                let span = node.parentElement;

                if (node instanceof Text && span instanceof HTMLSpanElement && node.parentElement && node.parentElement.parentElement == this.tokenField)
                {
                    let token = document.createElement('div');
                    token.setAttribute('contenteditable', 'false');
                    token.setAttribute('class', 'tag');
                    range.surroundContents(token);
                    token.innerText = 'TOKEN';

                    let firstTextNode = span.childNodes[0];
                    let secondTextNode = span.childNodes[2];

                    if (firstTextNode instanceof Text && secondTextNode instanceof Text)
                    {
                        let newSpan = document.createElement('span');
                        newSpan.appendChild(secondTextNode);

                        this.tokenField.insertBefore(token, span.nextSibling);
                        this.tokenField.insertBefore(newSpan, token.nextSibling);
                    }
                }
            }
        }
    }
}
